import { useEffect } from 'react';
import { usePushNotifications } from '../hooks/usePushNotifications';

interface PushNotificationManagerProps {
  agentId?: number;
}

export function PushNotificationManager({ agentId }: PushNotificationManagerProps) {
  const { isSupported, isSubscribed, subscribeToPush } = usePushNotifications();

  useEffect(() => {
    // Auto-s'abonner aux notifications push si supporté et pas encore abonné
    if (isSupported && !isSubscribed && agentId) {
      // Attendre un peu pour ne pas bloquer l'interface
      const timer = setTimeout(() => {
        subscribeToPush();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isSupported, isSubscribed, agentId, subscribeToPush]);

  // Le composant est invisible, il gère juste les notifications
  return null;
}
